// Generated by Melange

import * as Warblre_js__BigInt from "warblre-engines.js/BigInt.mjs";

const zero = Warblre_js__BigInt.zero;

const one = Warblre_js__BigInt.one;

const of_int = Warblre_js__BigInt.of_int;

const to_int = Warblre_js__BigInt.to_int;

const of_float = Warblre_js__BigInt.of_float;

const to_string = Warblre_js__BigInt.to_string;

const to_hex_string = Warblre_js__BigInt.to_hex_string;

const neg = Warblre_js__BigInt.neg;

const add = Warblre_js__BigInt.add;

const sub = Warblre_js__BigInt.sub;

const mult = Warblre_js__BigInt.mult;

const rem = Warblre_js__BigInt.rem;

const equal = Warblre_js__BigInt.equal;

const le = Warblre_js__BigInt.le;

const lt = Warblre_js__BigInt.lt;

const ge = Warblre_js__BigInt.ge;

const gt = Warblre_js__BigInt.gt;

const max = Warblre_js__BigInt.max;

const min = Warblre_js__BigInt.min;

const shift_left = Warblre_js__BigInt.shift_left;

const Nat = Warblre_js__BigInt.Nat;

export {
  zero,
  one,
  of_int,
  to_int,
  of_float,
  to_string,
  to_hex_string,
  neg,
  add,
  sub,
  mult,
  rem,
  equal,
  le,
  lt,
  ge,
  gt,
  max,
  min,
  shift_left,
  Nat,
}
/* Warblre_js__BigInt Not a pure module */
